var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrades = function SvgTrades(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6166 17.7172L25.3539 15.4544C25.1977 15.2982 24.9473 15.2953 24.7947 15.4479L14.4644 25.7782C13.6834 26.5592 13.6834 27.8255 14.4644 28.6066C15.2455 29.3876 16.5118 29.3876 17.2929 28.6066L27.6231 18.2763C27.7758 18.1237 27.7728 17.8734 27.6166 17.7172Z",
    fill: "#2595FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6462 20.5456L8.38343 18.2828C8.22722 18.1266 8.22431 17.8763 8.37693 17.7237L18.7072 7.3934C19.4882 6.61235 20.7546 6.61235 21.5356 7.3934C22.3167 8.17445 22.3167 9.44078 21.5356 10.2218L11.2054 20.5521C11.0527 20.7047 10.8024 20.7018 10.6462 20.5456Z",
    fill: "#2595FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.457 22.3829L7.68968 22.5362L7.68487 22.5364C7.46996 22.5433 7.30216 22.5487 7.16777 22.5414C7.03123 22.534 6.91938 22.5132 6.81927 22.4618C6.66806 22.3841 6.54497 22.261 6.46727 22.1098C6.41582 22.0097 6.39506 21.8978 6.38766 21.7613C6.38038 21.6269 6.38577 21.4591 6.39269 21.2442L6.39284 21.2394L6.54615 16.472L6.54634 16.4662C6.56003 16.0405 6.57053 15.7139 6.60103 15.4694C6.63131 15.2268 6.68339 15.0417 6.79867 14.9185C6.96532 14.7405 7.20292 14.6464 7.44621 14.6622C7.61453 14.6731 7.7791 14.7724 7.96714 14.9287C8.15654 15.0861 8.38755 15.3171 8.68864 15.6182L8.69274 15.6223L13.3068 20.2363L13.3109 20.2404C13.612 20.5415 13.843 20.7725 14.0004 20.9619C14.1566 21.15 14.256 21.3145 14.2669 21.4828C14.2826 21.7261 14.1885 21.9637 14.0105 22.1304C13.8874 22.2457 13.7023 22.2977 13.4596 22.328C13.2152 22.3585 12.8885 22.369 12.4628 22.3827L12.457 22.3829Z",
    stroke: "url(#paint0_linear_54_587)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4539 19.528L29.6072 14.7606L29.6073 14.7558C29.6142 14.5409 29.6196 14.3731 29.6124 14.2387C29.605 14.1022 29.5842 13.9903 29.5328 13.8902C29.4551 13.739 29.332 13.6159 29.1808 13.5382C29.0806 13.4868 28.9688 13.466 28.8323 13.4586C28.6979 13.4513 28.5301 13.4567 28.3151 13.4636L28.3103 13.4638L23.543 13.6171L23.5372 13.6173C23.1115 13.631 22.7849 13.6415 22.5404 13.672C22.2977 13.7023 22.1126 13.7543 21.9895 13.8696C21.8115 14.0363 21.7174 14.2739 21.7331 14.5172C21.744 14.6855 21.8434 14.8501 21.9996 15.0381C22.157 15.2275 22.388 15.4585 22.6891 15.7596L22.6932 15.7637L27.3073 20.3777L27.3114 20.3818C27.6125 20.6829 27.8435 20.9139 28.0329 21.0713C28.2209 21.2276 28.3855 21.3269 28.5538 21.3378C28.7971 21.3536 29.0347 21.2595 29.2014 21.0815C29.3166 20.9583 29.3687 20.7733 29.399 20.5306C29.4295 20.2861 29.44 19.9595 29.4537 19.5338L29.4539 19.528Z",
    stroke: "url(#paint1_linear_54_587)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3136 13.5637C28.7515 13.5497 28.9705 13.5426 29.135 13.6272C29.2677 13.6953 29.3757 13.8033 29.4438 13.9359C29.5284 14.1005 29.5213 14.3194 29.5072 14.7574L29.3539 19.5248C29.3262 20.386 29.3124 20.8166 29.1283 21.0131C28.9821 21.1693 28.7737 21.2518 28.5603 21.238C28.2916 21.2207 27.9871 20.9161 27.378 20.307L22.7639 15.693C22.1549 15.0839 21.8503 14.7793 21.8329 14.5107C21.8191 14.2973 21.9016 14.0888 22.0578 13.9426C22.2544 13.7586 22.685 13.7448 23.5462 13.7171L28.3136 13.5637Z",
    fill: "#67B6FE",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49279 21.2426C6.4787 21.6806 6.47166 21.8995 6.55621 22.0641C6.62437 22.1967 6.73233 22.3047 6.86497 22.3728C7.02951 22.4574 7.2485 22.4503 7.68647 22.4363L12.4538 22.283C13.315 22.2553 13.7456 22.2414 13.9422 22.0574C14.0984 21.9112 14.1809 21.7027 14.1671 21.4893C14.1497 21.2207 13.8452 20.9161 13.2361 20.307L8.62203 15.693C8.01294 15.0839 7.70839 14.7793 7.43976 14.762C7.22633 14.7482 7.01789 14.8307 6.87167 14.9869C6.68764 15.1834 6.6738 15.614 6.6461 16.4752L6.49279 21.2426Z",
    fill: "#67B6FE",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_54_587",
    x: -1.71582,
    y: 6.56047,
    width: 24.0845,
    height: 24.0844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_54_587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_54_587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_54_587",
    x: 13.6313,
    y: 5.35515,
    width: 24.0845,
    height: 24.0844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_54_587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_54_587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_54_587",
    x: 17.8315,
    y: 9.55513,
    width: 15.6843,
    height: 15.6844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_54_587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_54_587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_54_587",
    x: 4.48413,
    y: 12.7605,
    width: 11.6846,
    height: 11.6844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_54_587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_54_587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_587",
    x1: 3.0315,
    y1: 17.8163,
    x2: 16.5599,
    y2: 18.8303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_54_587",
    x1: 24.8873,
    y1: 10.1025,
    x2: 25.9013,
    y2: 23.6308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrades, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Trades.27d6cc23.svg";
export { ForwardRef as ReactComponent };